export enum AnalyticsTrackingDurationTab {
    Week = 'week',
    Month = 'month',
    Year = 'year'
}
